/**
 * DC Brands directory — live filter for the brand grid on /pages/brands.
 * Progressive enhancement: the full list is already in the HTML, this only
 * hides non-matching tiles as the shopper types.
 */
(function () {
  const grid = document.querySelector('[data-brands-grid]');
  const input = document.getElementById('dc-brands-filter');
  const countEl = document.querySelector('[data-brands-count]');
  const emptyEl = document.querySelector('[data-brands-empty]');

  if (!grid || !input) return;

  const items = Array.from(grid.querySelectorAll('.dc-brands__item'));
  const total = items.length;

  /** @param {number} n */
  const label = (n) => `${n} ${n === 1 ? 'brand' : 'brands'}`;

  const apply = () => {
    const q = input.value.trim().toLowerCase();
    let shown = 0;

    for (const item of items) {
      const name = item.dataset.brandName || '';
      const match = q === '' || name.includes(q);
      item.hidden = !match;
      if (match) shown++;
    }

    if (countEl) countEl.textContent = q === '' ? label(total) : `${label(shown)} of ${total}`;
    if (emptyEl) emptyEl.hidden = shown !== 0;
  };

  // Browsers restore the typed value of a search input across a reload, but the grid comes back
  // freshly rendered with every tile visible — so a shopper who reloads a filtered page would
  // see "amiri" in the box above all 26 brands. Re-apply whatever the box already holds.
  if (input.value.trim() !== '') apply();

  let frame = 0;
  input.addEventListener('input', () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(apply);
  });

  // Escape clears the filter.
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && input.value !== '') {
      input.value = '';
      apply();
    }
  });
})();
